import {
  FacebookLoginProvider,
  SocialAuthService,
} from '@abacritt/angularx-social-login'
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core'
import { toSignal } from '@angular/core/rxjs-interop'
import { filter, finalize } from 'rxjs/operators'
import { FeatureFlag } from '../../../constants/feature-flags'
import {
  HubtypeProviderAccount,
  WhatsappPhoneNumber,
} from '../../../models/hubtype-provider-account'
import { OrganizationService } from '../../../services/hubtype-api/organization.service'
import { ProviderAccountService } from '../../../services/hubtype-api/provider-account.service'
import { AngularComponent } from '../../AngularComponent'

@Component({
  selector: 'app-channels-whatsapp',
  templateUrl: './whatsapp.component.html',
  styleUrls: ['./whatsapp.component.scss'],
  standalone: false,
})
export class WhatsappComponent extends AngularComponent implements OnInit {
  @Input() provider: string
  phoneNumbers: WhatsappPhoneNumber[]
  selectedPhoneNumber: WhatsappPhoneNumber
  loadingPhoneNumbers = false
  feedback = false
  isCoexistenceMode = false

  readonly showCoexistenceButton = toSignal(
    this.organizationService.hasFeatureFlag(
      FeatureFlag.WHATSAPP_BUSINESS_APP_COEXISTENCE
    )
  )

  @Output() newChannel = new EventEmitter<HubtypeProviderAccount>()

  constructor(
    private providerAccountService: ProviderAccountService,
    private ref: ChangeDetectorRef,
    private socialAuthService: SocialAuthService,
    private organizationService: OrganizationService
  ) {
    super()
  }

  ngOnInit(): void {
    this.socialAuthService.authState.subscribe(user => {
      if (user.authToken) {
        // we check user.authToken to ensure the embedded signup process finished successfully
        this.getPhoneNumbers(user.authToken)
      } else {
        this.feedback = true
        console.log('SocialAuthService canceled. No user authtoken')
      }
    })
  }

  launchWhatsAppSignup() {
    this.isCoexistenceMode = false
    const fbLoginOptions = {
      scope:
        'business_management,whatsapp_business_management,whatsapp_business_messaging',
      extras: {
        feature: 'whatsapp_embedded_signup',
      },
    }
    this.socialAuthService.signIn(
      FacebookLoginProvider.PROVIDER_ID,
      fbLoginOptions
    )
  }

  launchWhatsAppCoexistenceSignup() {
    this.isCoexistenceMode = true
    const fbLoginOptions = {
      scope:
        'business_management,whatsapp_business_management,whatsapp_business_messaging',
      extras: {
        feature: 'whatsapp_embedded_signup',
        featureType: 'whatsapp_business_app_onboarding',
        sessionInfoVersion: '3',
      },
    }
    this.socialAuthService.signIn(
      FacebookLoginProvider.PROVIDER_ID,
      fbLoginOptions
    )
  }

  getPhoneNumbers(authToken: string) {
    this.feedback = false
    this.loadingPhoneNumbers = true

    this.providerAccountService
      .getWhatsappPhoneNumbers(this.provider, authToken)
      .pipe(
        filter(phoneNumbers => phoneNumbers && phoneNumbers.length > 0),
        finalize(() => {
          this.loadingPhoneNumbers = false
          this.ref.markForCheck()
        })
      )
      .subscribe(phoneNumbers => {
        if (phoneNumbers) {
          this.phoneNumbers = phoneNumbers
          this.selectedPhoneNumber = this.phoneNumbers[0]
        }
      })

    this.selectedPhoneNumber = this.phoneNumbers[0]
    this.loadingPhoneNumbers = false
  }

  addWhatsappCloud() {
    const provider = new HubtypeProviderAccount()
    provider.provider = this.provider
    provider.credentials_json = {
      waba_id: this.selectedPhoneNumber.waba_id,
      phone_number_id: this.selectedPhoneNumber.id,
      display_phone_name: this.selectedPhoneNumber.display_phone_name,
      display_phone_number: this.selectedPhoneNumber.display_phone_number,
      is_business_app_coexistence: this.isCoexistenceMode,
    }
    this.newChannel.emit(provider)
  }
}
